import { render, staticRenderFns } from "./SellerAdd.vue?vue&type=template&id=38f3896b&scoped=true&"
import script from "./SellerAdd.vue?vue&type=script&lang=js&"
export * from "./SellerAdd.vue?vue&type=script&lang=js&"
import style0 from "./SellerAdd.vue?vue&type=style&index=0&id=38f3896b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38f3896b",
  null
  
)

export default component.exports